module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Bold.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Bold.eot
 ** module id = 350
 ** module chunks = 0
 **/